export default "__VITE_ASSET__Ty9L8LBh__"